import type { SiteImageData } from "@/types/SiteImageData";
import Steam from "./Steam.svg";

export const SteamImage: SiteImageData = {
    src: Steam,
    alt: "Steam logo",
};
